import { data, useNavigate } from 'react-router'
import CtaSection from '#app/components/cta-section.tsx'
import Footer from '#app/components/footer.tsx'
import HeroCarousel from '#app/components/hero-carousel.tsx'
import { SegurosBeneficiosSection } from '#app/components/seguros/beneficios-section.tsx'
import { SegurosCardsSection } from '#app/components/seguros/cards-section.tsx'
import { SegurosLogosSection } from '#app/components/seguros/logos-section.tsx'
import {
	ContactoAliadosSchema,
	sendContactoAliadosEmail,
} from '#app/utils/email.server.ts'
import { type Route } from './+types/seguros.ts'
import { slidesSeguros } from './config.ts'
import { segurosEmpresas, segurosPersonas } from './seguros-config.ts'

export const meta: Route.MetaFunction = () => [
	{ title: '100prevalor - Seguros para personas y empresas' },
	{
		name: 'description',
		content:
			'Descubre nuestras soluciones de seguros para personas y empresas. Protección personalizada con compromiso sostenible.',
	},
]

export async function action({ request }: Route.ActionArgs) {
	const formData = await request.formData()

	const formDataObject = Object.fromEntries(formData)

	// Validar datos con Zod schema
	const validation = ContactoAliadosSchema.safeParse(formDataObject)

	if (!validation.success) {
		const errors: Record<string, string[]> = {}

		validation.error.errors.forEach((error) => {
			const field = error.path[0] as string
			if (!errors[field]) {
				errors[field] = []
			}
			errors[field].push(error.message)
		})

		return data({ success: false, errors })
	}

	try {
		// Enviar email usando el servicio
		await sendContactoAliadosEmail(validation.data)

		return data({
			success: true,
			message:
				'¡Gracias por tu interés! Hemos recibido tu información y te contactaremos pronto para explorar oportunidades de colaboración.',
		})
	} catch (error) {
		console.error('Error enviando formulario de aliados:', error)
		return data({
			success: false,
			message:
				'Ocurrió un error al enviar el formulario. Por favor intenta nuevamente o contactanos directamente.',
		})
	}
}

export default function SegurosPage() {
	const navigate = useNavigate()

	const handleInsuranceClick = (insuranceLink: string | undefined) => {
		if (insuranceLink) {
			void navigate(insuranceLink)
		} else {
			console.log('Insurance clicked:', insuranceLink)
			// TODO: Implement navigation for other insurance types
		}
	}

	return (
		<main className="font-parkinsans">
			{/* Hero Section */}
			<HeroCarousel
				showActionButton={false}
				showIndicators={false}
				showControls={false}
				slides={slidesSeguros}
			/>

			{/* Seguros para personas Section */}
			<SegurosCardsSection
				title="Seguros para personas"
				subtitle="Protección personalizada para tu tranquilidad"
				tagText="Individuales"
				tagIcon="user-full-view"
				tagColor="blue"
				insurances={segurosPersonas}
				onInsuranceClick={handleInsuranceClick}
			/>

			{/* Seguros para empresas y pymes Section */}
			<SegurosCardsSection
				title="Seguros para empresas y pymes"
				subtitle="Soluciones de seguros adaptadas al crecimiento de tu negocio"
				tagText="Empresariales"
				tagIcon="building-05"
				tagColor="green"
				insurances={segurosEmpresas}
				onInsuranceClick={handleInsuranceClick}
			/>

			{/* Empresas de seguros (Logos) Section */}
			<SegurosLogosSection />

			{/* Beneficios Clave Section */}
			<SegurosBeneficiosSection />

			{/* CTA Newsletter Section */}
			<CtaSection />

			{/* Footer */}
			<Footer />
		</main>
	)
}
